import { Injectable, Injector } from "@angular/core";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import "../../../../util/string";
import { KpiService } from "../../../../dashboardCommon/services/kpiService";
import { KpiServiceError, KpiServiceErrorType } from "../../../../dashboardCommon/services/kpiServiceError";
import { BucketStatusKpiCfg, BucketStatusKpiCfgService } from "./bucketsStatusKpiCfg.service";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";

export class BucketsStatusDetailServiceData {
    public link: string;

    constructor(link: string) {
        this.link = link;
    }
}

@Injectable()
export class BucketsStatusDetailService extends KpiService<BucketsStatusDetailServiceData> {
    public getClassName() { return "BucketsStatusDetailService"; }

    constructor(
        private serviceCfg: BucketStatusKpiCfgService,
        private apigeeService: ApigeeService,
        private officeSelectorService: OfficeSelectorService,
        injector: Injector) {
        super(injector);
    }

    protected async update(...args: any[]): Promise<BucketsStatusDetailServiceData> {
        if (this.apigeeService.apiToken && this.officeSelectorService.selectedOffice) {
            try {
                let cfg: BucketStatusKpiCfg = this.serviceCfg.getCfg();
                let url = cfg.bucketStatus.detailEndpointPattern.format(this.officeSelectorService.selectedOffice.id);
                return new BucketsStatusDetailServiceData(url);
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters,"KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }
}
